import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'

const firebaseConfig = {
  apiKey: 'AIzaSyAMDgrIefi_mfFeWZdY9wiauLWn-v4ZQCg',
  authDomain: 'bmedcare-7bdfa.firebaseapp.com',
  projectId: 'bmedcare-7bdfa',
  storageBucket: 'bmedcare-7bdfa.firebasestorage.app',
  messagingSenderId: '344832311739',
  appId: '1:344832311739:web:a42c073cf99a6fd75f049e',
  measurementId: 'G-XPELQJV09E',
}

const app = initializeApp(firebaseConfig)
export const db = getFirestore(app)
